var keyMirror = require("keyMirror");

module.exports = keyMirror({
	CHANGE_EVENT: null,

	CART_REMOVE_PENDING: null,
	CART_REMOVE_SUCCESS: null,
	CART_REMOVE_FAILED: null,

	CART_UPDATE_AMOUNT: null,

	CART_UPDATE_PENDING: null,
	CART_UPDATE_SUCCESS: null,
	CART_UPDATE_FAILED: null,

	CART_UPDATE_DONATION_AMOUNT_OPCO: null,
	CART_UPDATE_DONATION_CHARGE_TODAY_OPCO: null,
	CART_UPDATE_DONATION_FREQUENCY_OPCO: null,

	DISABLE_PAYPAL_CHECKOUT: null,
	ENABLE_PAYPAL_CHECKOUT: null,
	SET_SUBACCOUNT_GIFT_AMOUNT_OPCO: null,
	VALIDATE_PAYPAL_CHECKOUT: null
});
